<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title fw-bold">Create New Organisation</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body">
    <form>
      <!-- Company Name -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'Company Name *'"
          [(value)]="companyName"
          [placeholder]="'Company Name *'"
          [floating]="true"
        />
      </div>

      <!-- Organisation Number -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'Organisation Number'"
          [(value)]="organisationNumber"
          [placeholder]="'Organisation Number'"
          [floating]="true"
        />
      </div>

      <!-- Email -->
      <div class="mb-5">
        <app-input-component
          [type]="'email'"
          [label]="'Email'"
          [(value)]="email"
          [placeholder]="'Email'"
          [floating]="true"
        />
      </div>

      <!-- Phone -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'Phone'"
          [(value)]="phone"
          [placeholder]="'Phone'"
          [floating]="true"
        />
      </div>

      <!-- Address -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'Address'"
          [(value)]="address"
          [placeholder]="'Address'"
          [floating]="true"
        />
      </div>

      <!-- City and Postal Code -->
      <div class="row mb-5">
        <div class="col-md-8">
          <app-input-component
            [type]="'text'"
            [label]="'City'"
            [(value)]="city"
            [placeholder]="'City'"
            [floating]="true"
          />
        </div>
        <div class="col-md-4">
          <app-input-component
            [type]="'text'"
            [label]="'Postal Code'"
            [(value)]="postalCode"
            [placeholder]="'Postal Code'"
            [floating]="true"
          />
        </div>
      </div>

      <!-- Country -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'Country'"
          [(value)]="country"
          [placeholder]="'Country'"
          [floating]="true"
        />
      </div>

      <!-- Description -->
      <div class="mb-5">
        <div class="form-floating">
          <textarea
            class="form-control"
            id="description"
            rows="4"
            [(ngModel)]="description"
            [ngModelOptions]="{standalone: true}"
            placeholder="Description"
            style="height: 100px"
          ></textarea>
          <label for="description">Description</label>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <app-button
      [variant]="'neutral'"
      [label]="'Cancel'"
      (clicked)="close()"
    />
    <app-button
      [variant]="'primary'"
      [label]="loading ? 'Creating...' : 'Create Organisation'"
      [iconClass]="'fa fa-plus'"
      [disabled]="loading || !companyName"
      (clicked)="createOrganisation()"
    />
  </div>
</div>
